<template>
  <div class="mb-20">
    <div class="rounded bg-white">
      <div
        v-if="loadingError"
        class="flex justify-center items-center h-48 border-t border"
      >
        <p>Failed to load Schedule list</p>
      </div>
      <div
        v-else-if="loading"
        class="flex justify-center items-center h-48 border-t border"
      >
        <i class="fa fa-spin fa-circle-o-notch fa-3x" />
      </div>
      <div v-else>
        <schedule-list
          v-if="list.length"
          :list = "list"
        />
        <div
          v-else
          class="bg-white flex flex-col justify-center items-center border-t border"
        >
          <h2 class="p-4 text-sm">No Schedule found</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PtList, PtListItem } from '@pathao/ui-components/esm/List';
import { mapGetters } from 'vuex';
import ScheduleList from './list.vue';

export default {
  Name: 'ListSchedule',
  components: {
    PtList,
    PtListItem,
    ScheduleList,
  },
  computed: {
    ...mapGetters({
      list: 'schedules/scheduleList',
      loading: 'schedules/loading',
      loadingError: 'schedules/loadingError',
    }),
  },
};
</script>

<style>
  .line-item {
    width: fit-content;
    background: #f5f6f7;
    border-radius: 4px;
    padding: 4px 6px;
    max-width: 100%;
    word-wrap: break-word;
    height: max-content;
  }
  .pt-list-item > div {
    padding: 0 !important;
  }
  tr > th > span {
    margin-left: 1rem;
  }
  .schedule-list-td {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
  }
  .pt-table .pt-table-tbody {
    overflow: hidden !important;
  }
  @media screen and (max-width: 768px) {
    .schedule-list-td {
      align-items: end;
    }
  }
</style>
